import React from "react";
import { Link } from "react-router-dom";

const UnauthorizedPage = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 text-center">
                <div className="rounded-md bg-red-50 p-8">
                    <h2 className="text-2xl font-bold text-red-700 mb-4">
                        Accès non autorisé
                    </h2>
                    <p className="text-red-600 mb-6">
                        Vous n'avez pas les permissions nécessaires pour accéder à cette page. Seuls les administrateurs peuvent accéder à cette section.
                    </p>
                    <Link
                        to="/"
                        className="inline-block px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
                    >
                        Retour à l'accueil
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default UnauthorizedPage;